import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/leg-challenge/Index.vue')

export const indexLegChallengeRoute: RouteConfig = {
  path: '/activity/leg-challenge',
  name: 'activity_leg_challenge',
  component: Index,
  meta: {
    title: '最强大腿挑战赛',
  },
}

export default [indexLegChallengeRoute]
